import i18n from '../../base-dictionary';

const TASK_EVENT_TYPE_OPTIONS = [
  {
    value: 'assignee',
    label: i18n.t('common.assignee'),
  },
  {
    value: 'Component',
    label: i18n.t('common.component'),
  },
  {
    value: 'description',
    label: i18n.t('common.work_unit_description'),
  },
  {
    value: 'Story point estimate',
    label: `${i18n.t('common.estimation_singular')} estimate`,
  },
  {
    value: 'IssueParentAssociation',
    label: i18n.t('common.parent_task'),
  },
  {
    value: 'issuetype',
    label: i18n.t('common.type'),
  },
  {
    value: 'labels',
    label: i18n.t('common.labels_plural'),
  },
  {
    value: 'Story Points',
    label: i18n.t('common.estimation'),
  },
  {
    value: 'priority',
    label: i18n.t('common.priority'),
  },
  {
    value: 'reporter',
    label: i18n.t('common.reporter'),
  },
  {
    value: 'timeoriginalestimate',
    label: i18n.t('common.time_original_estimate'),
  },
];

const EVENT_MODEL_OPTIONS = [
  {
    value: 'task',
    label: i18n.t('common.work_unit'),
  },
  // TODO: Add change request event model when we support it
];

const MAPPING_RELATIONSHIP_OPTIONS = [
  {
    value: 'includes',
    label: 'Inside',
  },
  {
    value: 'excludes',
    label: 'Outside',
  },
];

type WorkflowPayload = {
  name: string;
  organization: string;
  subprojects: string[];
  steps: StepPayload[];
};

type MappingPayload = {
  external_name: string;
  order_index: number;
  is_important: boolean;
};

type StepPayload = {
  name: string;
  order_index: number;
  mappings: MappingPayload[];
};

type Mapping = {
  id: string;
  external_name: string;
  order_index: number;
  is_important: boolean;
};

type Step = {
  id: string;
  name: string;
  order_index: number;
  mappings: Mapping[];
};

type Workflow = {
  id: string;
  organization: string;
  name: string;
  subprojects: string[];
  steps: Step[];
  metadata_updated_at: string;
};

export { EVENT_MODEL_OPTIONS, MAPPING_RELATIONSHIP_OPTIONS, TASK_EVENT_TYPE_OPTIONS };
export type { Mapping, MappingPayload, Step, StepPayload, Workflow, WorkflowPayload };
